module.exports = "/work-site/img/traning.bc8a3ed7.png";